// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": require("gatsby-module-loader?name=component---src-templates-blog-post-js!W:\\www\\baumstarksoft\\www\\src\\templates\\blog-post.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!W:\\www\\baumstarksoft\\www\\src\\pages\\index.js"),
  "component---src-pages-new-page-js": require("gatsby-module-loader?name=component---src-pages-new-page-js!W:\\www\\baumstarksoft\\www\\src\\pages\\new-page.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!W:\\www\\baumstarksoft\\www\\.cache\\json\\layout-index.json"),
  "hello-world.json": require("gatsby-module-loader?name=path---hello-world!W:\\www\\baumstarksoft\\www\\.cache\\json\\hello-world.json"),
  "my-second-post.json": require("gatsby-module-loader?name=path---my-second-post!W:\\www\\baumstarksoft\\www\\.cache\\json\\my-second-post.json"),
  "hi-folks.json": require("gatsby-module-loader?name=path---hi-folks!W:\\www\\baumstarksoft\\www\\.cache\\json\\hi-folks.json"),
  "index.json": require("gatsby-module-loader?name=path---index!W:\\www\\baumstarksoft\\www\\.cache\\json\\index.json"),
  "new-page.json": require("gatsby-module-loader?name=path---new-page!W:\\www\\baumstarksoft\\www\\.cache\\json\\new-page.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!W:/www/baumstarksoft/www/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js